import React from 'react';
import { CircleAlertIcon } from 'lucide-react';
import { SectionBadge } from '../SectionBadge';
import { Reveal } from '../Reveal';
import { PAIN_CARDS, RESTART_STEPS } from '../../data/content';
export function Pain() {
  return <section className="w-full px-5 py-14 sm:py-20" data-id="element-164" data-mp="2du65337nvhkq">
      <div className="mx-auto max-w-5xl" data-id="element-165" data-mp="2hwav7rywhw2m">
        <Reveal className="text-center" data-id="element-166" data-mp="2hxc5hu83eeja">
          <SectionBadge data-id="element-167" data-mp="2hu7xsmvf50nv">¿Te suena?</SectionBadge>
          <h2 className="mx-auto mt-5 max-w-3xl font-display text-3xl leading-tight text-cocoa sm:text-5xl" data-id="element-168" data-mp="2mum1jspzlog3">
            Si tejés crochet, probablemente <span className="italic text-terra" data-id="element-169" data-mp="2rsdu8oyghelc">alguna de estas cosas</span> ya te pasó
          </h2>
        </Reveal>

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-170" data-mp="31ka6r51ah793">
          {PAIN_CARDS.map((card, index) => <Reveal key={card.title} delay={index % 3 * 60} as="article" data-id="element-171" data-mp="35meu5m1597na" data-mpi={index}>
              <div className="h-full rounded-2xl border border-sand-line bg-cream-card p-5 sm:p-6" data-id="element-172" data-mp="35kaksokh7gfm">
                <CircleAlertIcon className="h-5 w-5 text-terra" aria-hidden="true" data-id="element-173" data-mp="3aivj2ig63q1f" />
                <h3 className="mt-4 text-base font-bold leading-snug text-cocoa" data-id="element-174" data-mp="20m8ntrgxefr4">{card.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-cocoa-soft" data-id="element-175" data-mp="1wouhq8ojko3c">{card.desc}</p>
              </div>
            </Reveal>)}
        </div>

        <Reveal delay={80} className="mt-6" data-id="element-176" data-mp="1mp3qcfva2p7h">
          <div className="rounded-3xl bg-cocoa px-5 py-7 text-cream sm:px-10 sm:py-10" data-id="element-177" data-mp="1mqepg2ds38s9">
            <div className="grid gap-6 lg:grid-cols-[1fr_1.4fr] lg:items-center" data-id="element-178" data-mp="2kbsy76cnvw19">
              <div data-id="element-179" data-mp="2fekbqtkhd5u7">
                <h3 className="font-display text-3xl leading-tight sm:text-4xl" data-id="element-180" data-mp="2fe14c6sghzuf">Cada proyecto comienza desde cero</h3>
                <p className="mt-2 text-sm font-semibold text-gold" data-id="element-181" data-mp="2ak6cgg2p6ek9">Todo otra vez.</p>
              </div>
              <ol className="flex flex-wrap gap-2" data-id="element-182" data-mp="25llkf3xln16w">
                {RESTART_STEPS.map(step => <li key={step} className="rounded-full border border-cream/20 px-3.5 py-2 text-[13px] font-medium text-cream/90 sm:px-4 sm:text-sm" data-id="element-183" data-mp="3344yzono2p9a">
                    {step}
                  </li>)}
              </ol>
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}